import { CALC_MODELS } from '../../constants';
import CustomCo2Answer from './CustomCo2Answer';
import CarbonAnswer from './CarbonAnswer';

const componentMap = {
  [CALC_MODELS.CARBON]: CarbonAnswer,
  [CALC_MODELS.CUSTOM_CO2]: CustomCo2Answer,
};

const answersResolver = (componentName) => componentMap[componentName] || null;

export default answersResolver;
